var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49968 2.49992H12.4997V4.16658H10.8238C10.7705 5.22238 10.4947 6.25499 10.0143 7.19668C9.53387 8.13836 8.85983 8.96786 8.03634 9.63075L9.67218 10.8824L8.66051 12.2058L6.66634 10.6808L3.42217 13.1616L2.41051 11.8383L5.29634 9.63075C4.47286 8.96786 3.79882 8.13836 3.31842 7.19668C2.83803 6.25499 2.56214 5.22238 2.50884 4.16658H0.833008V2.49992H5.83301V0.833252H7.49968V2.49992ZM6.66634 8.58325L6.87634 8.42242C7.53769 7.91666 8.0831 7.27519 8.47594 6.54112C8.86877 5.80706 9.09992 4.9974 9.15384 4.16658H4.17884C4.23277 4.9974 4.46391 5.80706 4.85675 6.54112C5.24958 7.27519 5.795 7.91666 6.45634 8.42242L6.66634 8.58325Z",
    fill: "#8FBFFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9995 9.1665H12.3954L12.207 9.74067L9.20703 18.9073L10.7912 19.4257L11.5754 17.0298H15.9237L16.707 19.4257L18.2912 18.9073L15.2912 9.74067L15.1037 9.1665H12.9995ZM15.3779 15.3632L13.8954 10.8332H13.6037L12.1204 15.3632H15.3779Z",
    fill: "#2859C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/translation.3d09b0b6f7086a792bf7d54c3e89c927.svg";
export { ForwardRef as ReactComponent };